<script setup lang="ts" name="BaseCardLoading">
import Icon from '~/components/Icon.vue';

const { small = false } = defineProps<{
  small?: boolean;
}>();
</script>

<template>
  <div
    class="flex w-full flex-col items-center justify-center bg-white"
    :class="{ 'py-64': !small, 'py-32': small }"
  >
    <Icon icon="mdi:loading" size="3xl" class="animate-spin text-secondary-3" />
    <p class="mt-6 text-secondary-7">
      <slot>Hold tight! Just getting this page ready...</slot>
    </p>
  </div>
</template>
